module.exports = __webpack_public_path__ + "static/img/11.1724409.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/11.png
// module id = lcXN
// module chunks = 0